import React from "react";
import PropTypes from "prop-types";
import ActionLogger from "action-logger";

class ProTeaser extends React.Component {
  static propTypes = {
    handleClick: PropTypes.func.isRequired,
  };

  handleClick = () => {
    this.props.handleClick();
    ActionLogger.logAction({
      action: "pro_upsell_modal_join",
      object_type: "PRO",
      style_name: this.props.PdpStyleName,
    });
    this.props.closeModal();
  };

  logDetails = () => {
    ActionLogger.logAction({
      action: "pro_upsell_modal_details",
      object_type: "PRO",
      style_name: this.props.PdpStyleName,
    });
  };

  render() {
    var savings = "$14.95",
      annualCost = "$29.95";

    return (
      <div className="pro-teaser">
        <h3>{"Save at least " + savings + " on every order and rent like a pro all year long."}</h3>

        <p>
          <a className="standalone" href="/pages/rtr_pro" onClick={this.logDetails} target="_new">
            Details
          </a>
        </p>

        <ul className="pro-teaser__features">
          <li>
            <em>Free</em> Standard Shipping
          </li>
          <li>
            <em>Free</em> Insurance
          </li>
          <li>
            <em>Free</em> Birthday Dress
          </li>
        </ul>

        <div className="pro-teaser__action">
          <button onClick={this.handleClick} className="btn">
            {"Join now for " + annualCost + "/year"}
          </button>
        </div>

        <p className="pro-teaser__disclaimer fine-print">Renews automatically every year, cancel anytime.</p>
      </div>
    );
  }
}

export default ProTeaser;
